export default function BottomActionsProfile({
  activeTab,
  onEditPatient,
  onFillNewForm,
  onSendFormToPatient,
}) {
  if (activeTab === "main") {
    return (
      <div className="mt-8">
        <button
          type="button"
          onClick={onEditPatient}
          className="w-full flex justify-center items-center gap-2 border border-gray-300 rounded-md px-4 py-2 text-lg font-medium text-gray-900 hover:bg-gray-100"
        >
          <svg
            className="w-5 h-5 text-gray-900"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
            />
          </svg>
          Edit Main Information
        </button>
      </div>
    );
  }

  return (
    <div className="mt-8">
      <div className="px-4 py-2 flex justify-between items-center rounded-lg w-full gap-2">
        <button
          className="w-full flex justify-center items-center gap-2 border border-gray-300 rounded-md px-4 py-2 text-lg font-medium text-gray-900 hover:bg-gray-100"
          onClick={onSendFormToPatient}
        >
          <svg
            className="w-5 h-5 text-gray-900"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              fillRule="evenodd"
              d="M12 2a1 1 0 0 1 .932.638l7 18a1 1 0 0 1-1.326 1.281L13 19.517V13a1 1 0 1 0-2 0v6.517l-5.606 2.402a1 1 0 0 1-1.326-1.281l7-18A1 1 0 0 1 12 2Z"
              clipRule="evenodd"
            />
          </svg>
          Send Form to Patient
        </button>
        <button
          className="w-full flex justify-center items-center gap-2 border bg-blue-700 rounded-md px-4 py-2 text-lg font-medium text-white"
          onClick={onFillNewForm}
        >
          <svg
            className="w-5 h-5 text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M18 5V4a1 1 0 0 0-1-1H8.914a1 1 0 0 0-.707.293L4.293 7.207A1 1 0 0 0 4 7.914V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5M9 3v4a1 1 0 0 1-1 1H4m11.383.772 2.745 2.746m1.215-3.906a2.089 2.089 0 0 1 0 2.953l-6.65 6.646L9 17.95l.739-3.692 6.646-6.646a2.087 2.087 0 0 1 2.958 0Z"
            />
          </svg>
          Fill In New Form
        </button>
      </div>
    </div>
  );
}
